'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;
// import { Link } from 'react-router-dom';
// remove this one

// import { provideHooks } from 'redial';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('components');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _content = require('redux/modules/content');

var contentActions = _interopRequireWildcard(_content);

var _language = require('redux/modules/language');

var languageActions = _interopRequireWildcard(_language);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactKatex = require('react-katex');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _reactBootstrap = require('react-bootstrap');

var _formik = require('formik');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLoaded = contentActions.isLoaded,
    loadContent = contentActions.loadContent,
    updateContent = contentActions.updateContent;
var createWordToContent = languageActions.createWordToContent;
// import 'katex/dist/katex.min.css';
// require('katex/dist/katex.min.css');

var MyInnerForm = function MyInnerForm(props) {
  var lang = void 0;
  var values = props.values,
      touched = props.touched,
      errors = props.errors,
      dirty = props.dirty,
      isSubmitting = props.isSubmitting,
      handleChange = props.handleChange,
      handleLanguageChange = props.handleLanguageChange,
      handleBlur = props.handleBlur,
      handleSubmit = props.handleSubmit,
      handleReset = props.handleReset,
      lesson_by_id = props.lesson_by_id,
      updateLesson = props.updateLesson;

  return _react2.default.createElement(
    'form',
    { onSubmit: handleSubmit },
    _react2.default.createElement(
      'label',
      { htmlFor: 'title', style: { display: 'block' } },
      'Word'
    ),
    _react2.default.createElement('input', {
      id: 'title',
      placeholder: 'Enter your word',
      type: 'text',
      value: values.title,
      onChange: handleChange,
      onBlur: handleBlur,
      className: errors.title && touched.title ? 'text-input error' : 'text-input'
    }),
    errors.title && touched.title && _react2.default.createElement(
      'div',
      { className: 'input-feedback' },
      errors.title
    ),
    _react2.default.createElement(
      'label',
      { htmlFor: 'lang', style: { display: 'block' } },
      'Language'
    ),
    _react2.default.createElement('input', {
      id: 'lang',
      placeholder: 'Enter your lang',
      type: 'text',
      onChange: handleChange,
      onBlur: handleBlur,
      className: errors.lang && touched.lang ? 'text-input error' : 'text-input'
    }),
    errors.lang && touched.lang && _react2.default.createElement(
      'div',
      { className: 'input-feedback' },
      errors.lang
    ),
    _react2.default.createElement(
      'label',
      { htmlFor: 'type', style: { display: 'block' } },
      'Type: the whole word: 0, ...'
    ),
    _react2.default.createElement('input', {
      id: 'type',
      placeholder: 'Enter your type: 1,2',
      type: 'number',
      onChange: handleChange,
      onBlur: handleBlur,
      className: errors.type && touched.type ? 'text-input error' : 'text-input'
    }),
    errors.type && touched.type && _react2.default.createElement(
      'div',
      { className: 'input-feedback' },
      errors.type
    ),
    _react2.default.createElement(
      'button',
      { type: 'submit', disabled: isSubmitting },
      'Submit'
    )
  );
};

var EnhancedForm = (0, _formik.withFormik)({
  mapPropsToValues: function mapPropsToValues() {
    return {
      title: '',
      lang: 'en',
      type: 1
    };
  },
  // validationSchema: Yup.object().shape({
  //   title: Yup.string()
  //     .required('Title is required!'),
  //   title: Yup.string()
  //     .required('Title is required!'),
  // }),
  handleSubmit: function handleSubmit(values, _ref) {
    var props = _ref.props,
        setSubmitting = _ref.setSubmitting;

    // props.onChange(values);
    setTimeout(function () {
      props.onChange(values);
      // alert(JSON.stringify(values, null, 2));
      // props.createWordToContent(values.title, props.content.id, values.lang);
      console.log(values);
      console.log(props);
      setSubmitting(false);
    }, 1000);
  },
  displayName: 'BasicForm' // helps with React DevTools
})(MyInnerForm);

// @connect(state => ({
//   online: state.online
// }))
var ContentEditor = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref2) {
    var _ref2$store = _ref2.store,
        dispatch = _ref2$store.dispatch,
        getState = _ref2$store.getState,
        id = _ref2.params.id,
        location = _ref2.location;

    // console.log("asyncConnect");
    // if (!isLoaded(getState())) {
    // }
    //Should check to be different!!!
    console.log("hey");
    if (id !== undefined && id !== null) {
      console.log("has no id");
    }
    return dispatch(loadContent(id));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    content: state.content.data
    // editing: state.widgets.editing,
    // error: state.widgets.error,
    // loading: state.widgets.loading
  };
}, (0, _extends3.default)({}, contentActions, languageActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ContentEditor, _Component);

  function ContentEditor() {
    (0, _classCallCheck3.default)(this, ContentEditor);
    return (0, _possibleConstructorReturn3.default)(this, (ContentEditor.__proto__ || (0, _getPrototypeOf2.default)(ContentEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(ContentEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // require('katex/dist/katex.min.css');
      this.forceUpdate();
    }
  }, {
    key: 'transform',
    value: function (_transform) {
      function transform(_x, _x2) {
        return _transform.apply(this, arguments);
      }

      transform.toString = function () {
        return _transform.toString();
      };

      return transform;
    }(function (node, index) {
      // convert <ul> to <ol>
      if (node.type === 'tag' && node.name === 'inlinemath') {
        node.name = 'InlineMath';
        return (0, _reactHtmlParser.convertNodeToElement)(node, index, transform);
      }
    })
  }, {
    key: 'handleTextareaChange',
    value: function handleTextareaChange(event) {
      console.log("changing...");
      if (!this.props.content.id) {
        this.props.content.id = 0;
      }
      if (!this.props.content.name) {
        this.props.content.name = "";
      }
      if (!this.props.content.ctgType) {
        this.props.content.ctgType = "theory";
      }
      this.props.content.data = event.target.value;
      this.forceUpdate();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // require('../../theme/katex.css');
      var _props = this.props,
          content = _props.content,
          createWordToContent = _props.createWordToContent;

      var styles = require('./Home.scss');
      // require the logo image both from client and server
      var logoImage = require('./logo.png');

      return _react2.default.createElement(
        'div',
        { className: styles.home },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Content' }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'p',
            null,
            'Change lessson'
          ),
          _react2.default.createElement(_components.LessonSelection, {
            onChange: function onChange(data) {
              console.log("got cha!!");
              console.log(data);
              _this2.setState({
                lessonValue: data
              });
            }
          }),
          this.state && this.state.lessonValue && _react2.default.createElement(
            _reactBootstrap.Button,
            { onClick: function onClick() {
                console.log("onclick");
                console.log(_this2.state.lessonValue);

                //EDIT content, change lessonId
                content.lessonsId = _this2.state.lessonValue.id;
                content.lessonId = _this2.state.lessonValue.id;

                _this2.props.updateContent(content);
              } },
            'Save'
          )
          //   <Button onClick={() => {
          //
          //   }}>
          //   {t('content.save_content_to_lesson')}
          // </Button>
          ,
          false && content && // Ideas: create multiple editor to switch between modes,
          // and of course, pure mode: for editing Html purely.
          // prevent losing data.... at first place.
          _react2.default.createElement(_components.TextEditor, { content: content.data }),
          _react2.default.createElement(
            'p',
            null,
            'Select a language (default: en)'
          ),
          _react2.default.createElement('textarea', {
            value: content ? content.data : "",
            onChange: this.handleTextareaChange.bind(this) }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'Link to reminder...'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Include: '
            ),
            _react2.default.createElement(
              'p',
              null,
              'A droplist to choose a specific language, but first, just enter \'code\' directly.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'A droplist to choose a word, Nope, don\'t need to do this. Just type a word... that\'s much easier'
            ),
            _react2.default.createElement(
              'p',
              null,
              'An another droplist to choose type (whole word or surfix, or something else...)'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Then need to check that is exists in word_to_content? or not'
            ),
            _react2.default.createElement(
              _reactBootstrap.Button,
              { onClick: function onClick() {
                  console.log("save content");
                  console.log(content.data);

                  //EDIT content, change lessonId
                  // content.data = this.state.lessonValue.id;

                  _this2.props.updateContent(content);
                } },
              'Save the content '
            )
          ),
          _react2.default.createElement('div', null),
          content && content.active && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('b', { dangerouslySetInnerHTML: { __html: content.name } }),
            _react2.default.createElement(
              'div',
              null,
              content && (0, _reactHtmlParser2.default)(content.data, { decodeEntities: true, transform: function transform(node, index) {
                  if (node.type === 'tag' && node.name === 'span' && node.attribs.class === "math-q") {
                    // node.name = 'InlineMath';
                    // console.log("what");
                    // console.log(node);
                    // console.log(index);
                    return _react2.default.createElement(_reactKatex.InlineMath, { math: node.children[0].data.slice(2, -2) });
                  }

                  //Find image tag: <span><img src=\"content/lessons/28/obitan_1.PNG\" /></span>
                  if (node.type === 'tag' && node.name === 'img') {
                    // console.log(node);
                    if (node.attribs.src.startsWith('content/lessons/')) {
                      // console.log("matchedddd.....");
                      var newSrc = 'http://hochochoc.com/www/' + node.attribs.src; //should be dynamic.... by using env...

                      return _react2.default.createElement('img', { src: newSrc });
                    }
                  }
                } })
            ),
            _react2.default.createElement('el', null)
          ),
          _react2.default.createElement(
            'p',
            null,
            '-----'
          ),
          _react2.default.createElement(EnhancedForm, (0, _extends3.default)({}, this.props, { onChange: function onChange(data) {
              console.log('data');
              console.log(data);
              // console.log(this.props);
              createWordToContent(data.title, content.id, data.type, data.lang);
            } }))
        )
      );
    }
  }]);
  return ContentEditor;
}(_react.Component), _class2.propTypes = {
  content: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = ContentEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Content/ContentEditor.js
// module id = 1517
// module chunks = 0